import type { ResourceResponse } from 'types';
import { isResponseValid } from 'features/auth/helpers';
import { logout } from 'features/auth/slice';
import type { AnyAction, MiddlewareAPI, Middleware } from '../lib';

export const globalErrorHandler: Middleware =
    ({ dispatch }: MiddlewareAPI) => (next) => (action: AnyAction) => {
        if (!isResponseValid(action.payload as ResourceResponse<any>)) {
            dispatch(logout());
        }

        return next(action)
    };

export default globalErrorHandler;
